import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { useCurrentInstanceType } from '../Helper';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function MultiTabs({
  childrenA,
  childrenB,
  childrenC,
  childrenD,
  childrenE,
  childrenF
}) {

  const [value, setValue] = React.useState(0);
  const { type } = useCurrentInstanceType()

  // const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack className='multitab-container'>
      {/* < style={{ borderBottom: '1px solid #ddd' }}> */}
      <Tabs
        value={value}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        textColor="primary"
        indicatorColor="primary"
        aria-label="primary tabs example"
        style={{
          borderBottom: '1px solid #ddd',
          width: '100%'
        }}
      >
        {/* Check if children are provided before rendering tabs */}

        {childrenA && (
          <Tab
            label="Instances"
            style={{ textTransform: 'none' }}
            {...a11yProps(0)} />
        )}

        {childrenB && (
          <Tab
            label="Scheduled Events"
            style={{ textTransform: 'none' }}
            {...a11yProps(1)} />
        )}
        
        {childrenC && (
          <Tab
            disabled={!['rds', 'ec2'].includes(type)}
            label="Idle Events"
            style={{ textTransform: 'none' }}
            {...a11yProps(2)} />
        )}

        {childrenD && (
          <Tab
            label="Activity Events"
            style={{ textTransform: 'none' }}
            {...a11yProps(3)} />
        )}

        {childrenE && (
          <Tab
            label="Modification Events"
            style={{ textTransform: 'none' }}
            {...a11yProps(4)} />
        )}

        {childrenF && (
          <Tab
            label="Saving"
            style={{ textTransform: 'none' }}
            {...a11yProps(5)} />
        )}
      </Tabs>
      {/* </Box> */}

      {/* Render tab panels based on provided children */}
      <CustomTabPanel value={value} index={0}>{childrenA}</CustomTabPanel>

      <CustomTabPanel value={value} index={1}>{childrenB}</CustomTabPanel>

      <CustomTabPanel value={value} index={2}>{childrenC}</CustomTabPanel>

      <CustomTabPanel value={value} index={3}>{childrenD}</CustomTabPanel>

      <CustomTabPanel value={value} index={4}>{childrenE}</CustomTabPanel>

      <CustomTabPanel value={value} index={5}>{childrenF}</CustomTabPanel>
    </Stack>
  );
}
